var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "app-survey-stepper"
    },
    [
      _c(
        "div",
        {
          staticClass: "app-survey-stepper__content"
        },
        [
          _vm._t("default", null, {
            step: _vm.step,
            steps: _vm.steps,
            isFirst: _vm.isFirstStep,
            isLast: _vm.isLastStep,
            previousStep: _vm.previousStep,
            nextStep: _vm.nextStep
          })
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hideControlsForSteps.includes(_vm.step),
              expression: "!hideControlsForSteps.includes(step)"
            }
          ],
          staticClass: "app-survey-stepper__controls"
        },
        [
          _vm._t(
            "controls",
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    text: "",
                    disabled: _vm.isFirstStep || _vm.loading
                  },
                  on: {
                    click: _vm.previousStep
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        left: "",
                        small: ""
                      }
                    },
                    [_vm._v("mdi-chevron-left")]
                  ),
                  _vm._v(" " + _vm._s(_vm.backLabel) + " ")
                ],
                1
              ),
              _c("span", [
                _vm._v(
                  " Step " +
                    _vm._s(_vm.step + 1 - _vm.hideControlsForSteps.length) +
                    " of " +
                    _vm._s(_vm.steps - _vm.hideControlsForSteps.length) +
                    " "
                )
              ]),
              _c(
                "gg-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLastStep,
                      expression: "!isLastStep"
                    }
                  ],
                  attrs: {
                    text: "",
                    disabled: _vm.loading
                  },
                  on: {
                    click: _vm.nextStep
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.nextLabel) + " "),
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        right: "",
                        small: ""
                      }
                    },
                    [_vm._v("mdi-chevron-right")]
                  )
                ],
                1
              ),
              _c(
                "gg-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLastStep,
                      expression: "isLastStep"
                    }
                  ],
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: function click($event) {
                      return _vm.$emit("finish")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.finishLabel) + " ")]
              )
            ],
            {
              nextStep: _vm.nextStep,
              previousStep: _vm.previousStep,
              step: _vm.step,
              steps: _vm.steps,
              hideControlsForSteps: _vm.hideControlsForSteps,
              isFirstStep: _vm.isFirstStep,
              isLastStep: _vm.isLastStep
            }
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }